import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Media from 'local_modules/Media'
import cx from 'classnames'

import Cell from '../Cell/Cell'

import s from './Grid.scss'


const Grid = ({ children, id, className, columns, gutter, noWrap }) => {
  const gridClassName = cx(s.grid, className, {
    [s[`gutter_${gutter}`]]: gutter, // gutter_xlg, ...
    [s.noWrap]: noWrap,
  })

  const getGrid = (columnsCount) => (
    <div id={id} className={gridClassName} role="list">
      {
        React.Children.map(children, (child) => {
          if (!child) {
            return null
          }

          if (child.type === Cell) {
            return React.cloneElement(child, { columns: columnsCount, gutter })
          }

          return (
            <Cell columns={columnsCount} gutter={gutter}>
              {child}
            </Cell>
          )
        })
      }
    </div>
  )

  if (typeof columns === 'number') {
    return getGrid(columns)
  }

  if (typeof columns === 'object') {
    return (
      <Fragment>
        {
          Object
            .keys(columns)
            .map((key) => {
              const mediaType = { [key]: true }

              return (
                <Media key={key} {...mediaType}>
                  {
                    (isMatches) => isMatches && getGrid(columns[key])
                  }
                </Media>
              )
            })
        }
      </Fragment>
    )
  }

  return null
}

Grid.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
  // columns: PropTypes.oneOf(array.range(1, 12)),
  gutter: PropTypes.oneOf([
    'xsm', 'sm', 'md', 'lg', 'xlg',
    4, 8, 12, 16, 20, 24,
  ]),
  noWrap: PropTypes.bool,
}

Grid.defaultProps = {
  columns: 1,
  noWrap: false,
}


export default Grid
